import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Package, ShoppingBag, BarChart3 } from 'lucide-react';

/**
 * Three top-of-dashboard tiles: Total Services / Active Listings / Total
 * Bookings. Receives the merchant's stats payload (`{total_services,
 * active_services, total_bookings}`) from the parent.
 */
export function MerchantStatsCards({ stats }) {
  const tiles = [
    { label: 'Total Services', value: stats?.total_services, icon: Package, color: '#00E5FF' },
    { label: 'Active Listings', value: stats?.active_services, icon: ShoppingBag, color: '#00E676' },
    { label: 'Total Bookings', value: stats?.total_bookings, icon: BarChart3, color: '#FFD740' },
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
      {tiles.map((s) => (
        <Card key={s.label} className="bg-[#041A3B] border-white/10">
          <CardContent className="p-4 flex items-center gap-4">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${s.color}15` }}>
              <s.icon className="w-5 h-5" style={{ color: s.color }} />
            </div>
            <div>
              <p className="text-[#5C7599] text-xs">{s.label}</p>
              <p className="text-white text-xl font-bold font-outfit">{s.value || 0}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
